import _ from "lodash";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Grid, Button, Message } from "semantic-ui-react";
import queryString from "query-string";
import { useParams, Redirect, useHistory } from "react-router-dom";
import { resetPassword } from "../../../actions/identity";
import identitySelectors from "../../../selectors/identity";

export default function ResetPasswordForm() {
  const dispatch = useDispatch();
  const params = useParams<{ site: string }>();
  const { email, token, redirect } = queryString.parse(window.location.search) as {
    email: string;
    token: string;
    redirect: string;
  };
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const submit = function (event: any) {
    event.preventDefault();
    dispatch(resetPassword({ site: params.site, email, token, password, confirmPassword }));
  };
  const history = useHistory();

  const postResetPassword = useSelector(identitySelectors.postResetPassword);
  const isLoggedIn = identitySelectors.isLoggedIn();

  const renderResetFailure = () => (
    <Message className='feedback' negative>
      {_.get(postResetPassword, "error.response.error") ??
        postResetPassword?.error?.message ??
        "We were unable to reset your password."}
    </Message>
  );

  useEffect(() => {
    const success = postResetPassword.payload;
    if (success) {
      const isPublic = window.location.pathname.includes("/public");
      const urlParams = new URLSearchParams();
      if (redirect) urlParams.set("redirect", redirect);
      urlParams.set("message", "Successfully reset password. Please log in with your new password.");
      history.push(`/${params.site}${isPublic ? "/public" : ""}/login?${urlParams.toString()}`);
    }
  }, [postResetPassword.payload, dispatch, params.site, email, password]);

  if (isLoggedIn) {
    return (
      <Redirect
        to={{
          pathname: `/${params.site}/landing`,
          search: queryString.stringify({
            redirect: redirect,
            remember: true,
          }),
        }}
      />
    );
  }

  return (
    <>
      {_.get(postResetPassword, "error") ? renderResetFailure() : null}
      <Form>
        <p className='tw-pt-4'>
          Please enter the new password for <b>{email}</b>
        </p>
        <Form.Field>
          <label htmlFor='password'>New Password</label>
          <input type='password' onChange={(e) => setPassword(e.target.value)} value={password} />
        </Form.Field>
        <Form.Field>
          <label htmlFor='confirmPassword'>Confirm New Password</label>
          <input type='password' onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} />
        </Form.Field>
        <Form.Field>
          <Grid.Column>
            <Button primary size='large' onClick={submit} className='tw-mt-4'>
              Set Password
            </Button>
          </Grid.Column>
        </Form.Field>
      </Form>
    </>
  );
}
